export const NAV = 'nav';
export const UIIFRAME = 'uiiframe';
export const EXTENSION_UIIFRAME = 'extension-uiiframe';